/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ResponseFailed } from './ResponseFailed';
import {
    ResponseFailedFromJSON,
    ResponseFailedFromJSONTyped,
    ResponseFailedToJSON,
    ResponseFailedToJSONTyped,
} from './ResponseFailed';
import type { ResponseSuccess } from './ResponseSuccess';
import {
    ResponseSuccessFromJSON,
    ResponseSuccessFromJSONTyped,
    ResponseSuccessToJSON,
    ResponseSuccessToJSONTyped,
} from './ResponseSuccess';

/**
 * 
 * @export
 * @interface ResponseCreateInboundPlanResponse
 */
export interface ResponseCreateInboundPlanResponse {
    /**
     * 
     * @type {Array<ResponseFailed>}
     * @memberof ResponseCreateInboundPlanResponse
     */
    failed?: Array<ResponseFailed>;
    /**
     * 
     * @type {Array<ResponseSuccess>}
     * @memberof ResponseCreateInboundPlanResponse
     */
    success?: Array<ResponseSuccess>;
}

/**
 * Check if a given object implements the ResponseCreateInboundPlanResponse interface.
 */
export function instanceOfResponseCreateInboundPlanResponse(value: object): value is ResponseCreateInboundPlanResponse {
    return true;
}

export function ResponseCreateInboundPlanResponseFromJSON(json: any): ResponseCreateInboundPlanResponse {
    return ResponseCreateInboundPlanResponseFromJSONTyped(json, false);
}

export function ResponseCreateInboundPlanResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseCreateInboundPlanResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'failed': json['failed'] == null ? undefined : ((json['failed'] as Array<any>).map(ResponseFailedFromJSON)),
        'success': json['success'] == null ? undefined : ((json['success'] as Array<any>).map(ResponseSuccessFromJSON)),
    };
}

export function ResponseCreateInboundPlanResponseToJSON(json: any): ResponseCreateInboundPlanResponse {
    return ResponseCreateInboundPlanResponseToJSONTyped(json, false);
}

export function ResponseCreateInboundPlanResponseToJSONTyped(value?: ResponseCreateInboundPlanResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'failed': value['failed'] == null ? undefined : ((value['failed'] as Array<any>).map(ResponseFailedToJSON)),
        'success': value['success'] == null ? undefined : ((value['success'] as Array<any>).map(ResponseSuccessToJSON)),
    };
}

